export default "__VITE_ASSET__lmExdBtjnYpNskmFJV_eKw__ 480w, __VITE_ASSET__jdaKWzxDdLISUlRyIgaZpQ__ 770w";